<script setup>
    import { onMounted, computed } from 'vue'
    import { useWebChatFullStore } from '@/stores/webChatFull'
    import Store, { setState } from '@/store'

    import SelectChat from '@/components/Wizard/SteepChat.vue'

    const webChatFullStore = useWebChatFullStore()

    const isWebChatFull = computed(() => webChatFullStore.me)

    function handleUpdateStore() {
        setState(isWebChatFull.value)
    }

    onMounted(() => {
        handleUpdateStore()
    })

</script>
<template>
    <SelectChat
        v-if="Store?.wsToken"
        :fix-height="false"
    />
</template>
